import videojs from 'video.js';
import { SrsRtcPlayerAsync } from '../../../../libraries/srs.sdk';

const Html5 = videojs.getTech('html5');

class WebRtcHashTech extends Html5 {

    constructor(options, ready) {
        super(options, ready);

        this.webRtcPlayer = null;
    }

    setSrc(src) {
        if (this.webRtcPlayer) {
            this.webRtcPlayer.close();
        }

        this.webRtcPlayer = this.createSrsPlayer(this.options_.source.config);

        this.webRtcPlayer.play(this.el_, null, src);
    }

    createSrsPlayer(config) {
        return new SrsRtcPlayerAsync({
            apiUrl: config.apiUrl,
            apiToken: config.token,

            onConnectionStateChange: function(connectionState) {
                console.log('Live player connection state changed: ' + connectionState.target.connectionState);
                if (connectionState.target.connectionState === 'disconnected') {
                    this.pause();
                }
            }.bind(this),
        });
    }

    dispose() {
        if (this.webRtcPlayer) {
            this.webRtcPlayer.close();
        }

        super.dispose();
    }
}

WebRtcHashTech.formats = [
    'webrtc-hash',
];

WebRtcHashTech.canPlayType = function(type) {
    if (WebRtcHashTech.formats.includes(type)) {
        return 'maybe';
    }

    return '';
};

WebRtcHashTech.canPlaySource = function(srcObj) {
    return WebRtcHashTech.canPlayType(srcObj.type);
};

WebRtcHashTech.VERSION = '__VERSION__';

videojs.registerTech('WebRtcHash', WebRtcHashTech);

export default WebRtcHashTech;
